import {daysBetween, getTodayStartTime} from 'shared/utils/dateTime';

export function futureDaysCount(budget: BudgetState, settingsView: SettingsViewState): number {
  const {tempBudgetFinishDate: future} = settingsView;
  const {finishDate: current} = budget;
  const finishDate = future || current;
  return daysBetween(finishDate, getTodayStartTime());
}
